module.exports = __webpack_public_path__ + "img/logo.63470ca5.png";